var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoteSuccessIcon = function SvgNoteSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m4.237-11.283q.121.05.216.143a.65.65 0 0 1 .214.479.64.64 0 0 1-.214.48l-5.42 5.321a.67.67 0 0 1-.47.193.68.68 0 0 1-.472-.193L3.54 8.636a.67.67 0 0 1-.208-.468.66.66 0 0 1 .19-.475A.68.68 0 0 1 4 7.49a.7.7 0 0 1 .484.187l2.078 2.048L11.51 4.86a.67.67 0 0 1 .471-.193q.133 0 .256.05",
    clipRule: "evenodd"
  })));
};
export { SvgNoteSuccessIcon as ReactComponent };